import { httpClient } from '../http/httpClient'
import { SupportTransactionSummary } from './createSupport'

export type PersonTransactionRole = 'customer' | 'seller'
// 'pending': propostas em andamento · 'documents': com documento anexado ·
// 'all': todas as propostas da pessoa
export type PersonTransactionFilter = 'pending' | 'documents' | 'all'

export interface ListPersonTransactionsParams {
  personId: string
  role: PersonTransactionRole
  filter: PersonTransactionFilter
  limit?: number
  skip?: number
}

export interface ListPersonTransactionsResponse {
  transactions: SupportTransactionSummary[]
  pagination: {
    limit: number
    skip: number
    total: number
  }
}

export async function listPersonTransactions(
  params: ListPersonTransactionsParams,
) {
  const { data } = await httpClient.get<ListPersonTransactionsResponse>(
    '/support/person-transactions',
    { params },
  )

  return data
}
